
// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import Header from '../dashboard/components/Header';
// import Sidebar from '../dashboard/components/Sidebar';
// import UsersManagement from './components/UsersManagement';
// import RolesPermissions from './components/RolesPermissions';
// import AuditLog from './components/AuditLog';

// export default function AdminPage() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState('users');
//   const navigate = useNavigate();

//   const tabs = [
//     { id: 'users', label: 'Utilisateurs', icon: 'ri-user-line' },
//     { id: 'roles', label: 'Rôles', fullLabel: 'Rôles & Permissions', icon: 'ri-shield-user-line' },
//     { id: 'audit', label: 'Audit', fullLabel: 'Journal d\'Audit', icon: 'ri-file-list-3-line' }
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50">
//       <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
//       <div className="flex">
//         <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
//         <main className="flex-1 p-4 sm:p-6 lg:ml-64 pt-20 sm:pt-24">
//           <div className="max-w-7xl mx-auto">
//             <div className="mb-6 sm:mb-8 flex items-center space-x-4">
//               <button
//                 onClick={() => navigate('/dashboard')}
//                 className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
//                 title="Retour au tableau de bord"
//               >
//                 <i className="ri-arrow-left-line text-xl text-gray-600"></i>
//               </button>
//               <div>
//                 <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">Administration</h1>
//                 <p className="text-sm sm:text-base text-gray-600">Gestion des utilisateurs, rôles et sécurité du système</p>
//               </div>
//             </div>

//             <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 sm:mb-6">
//               <div className="flex border-b border-gray-200 overflow-x-auto">
//                 {tabs.map((tab) => (
//                   <button
//                     key={tab.id}
//                     onClick={() => setActiveTab(tab.id)}
//                     className={`flex items-center space-x-2 px-4 sm:px-6 py-3 sm:py-4 font-medium transition-colors whitespace-nowrap text-sm sm:text-base ${
//                       activeTab === tab.id
//                         ? 'text-blue-600 border-b-2 border-blue-600'
//                         : 'text-gray-600 hover:text-gray-900'
//                     }`}
//                   >
//                     <i className={`${tab.icon} text-lg`}></i>
//                     <span className="hidden sm:inline">{tab.fullLabel || tab.label}</span>
//                     <span className="sm:hidden">{tab.label}</span>
//                   </button>
//                 ))}
//               </div>

//               <div className="p-4 sm:p-6">
//                 {activeTab === 'users' && <UsersManagement />}
//                 {activeTab === 'roles' && <RolesPermissions />}
//                 {activeTab === 'audit' && <AuditLog />}
//               </div>
//             </div>
//           </div>
//         </main>
//       </div>
//     </div>
//   );
// }

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../dashboard/components/Header';
import Sidebar from '../dashboard/components/Sidebar';
import UsersManagement from './components/UsersManagement';
import RolesPermissions from './components/RolesPermissions';
import AuditLog from './components/AuditLog';

export default function AdminPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('users');
  const navigate = useNavigate();

  const tabs = [
    { id: 'users', label: 'Utilisateurs', icon: 'ri-user-line' },
    { id: 'roles', label: 'Rôles', fullLabel: 'Rôles & Permissions', icon: 'ri-shield-user-line' },
    { id: 'audit', label: 'Audit', fullLabel: 'Journal d\'Audit', icon: 'ri-file-list-3-line' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header fixe en haut */}
      <Header onMenuClick={() => setSidebarOpen(true)} />

      {/* Overlay sidebar mobile */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
          className="fixed inset-y-0 left-0 z-50 lg:static lg:translate-x-0 transform transition-transform duration-300 ease-in-out lg:w-64"
        />

        {/* Contenu principal */}
<main className="flex-1 overflow-y-auto pt-16 lg:pt-16 lg:ml-64">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8">
            {/* En-tête avec bouton retour */}
            <div className="mb-6 flex items-center gap-3 sm:gap-4">
              <button
                onClick={() => navigate('/dashboard')}
                className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
                title="Retour au tableau de bord"
                aria-label="Retour"
              >
                <i className="ri-arrow-left-line text-xl text-gray-700"></i>
              </button>

              <div>
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
                  Administration
                </h1>
                <p className="text-sm text-gray-600 mt-1 hidden sm:block">
                  Gestion des utilisateurs, rôles et sécurité du système
                </p>
              </div>
            </div>

            {/* Onglets */}
            <div className="bg-white rounded-xl shadow border border-gray-200 overflow-hidden">
              {/* Barre d'onglets scrollable */}
              <div className="border-b border-gray-200 overflow-x-auto scrollbar-thin">
                <div className="flex min-w-max">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`
                        flex items-center gap-2 px-4 sm:px-6 py-3.5 font-medium text-sm sm:text-base
                        whitespace-nowrap transition-colors
                        ${
                          activeTab === tab.id
                            ? 'text-blue-600 border-b-2 border-blue-600 bg-blue-50/40'
                            : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                        }
                      `}
                    >
                      <i className={`${tab.icon} text-lg sm:text-xl`}></i>
                      <span className="hidden sm:inline">{tab.fullLabel || tab.label}</span>
                      <span className="sm:hidden">{tab.label}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Contenu de l'onglet actif */}
              <div className="p-4 sm:p-6 lg:p-8">
                {activeTab === 'users' && <UsersManagement />}
                {activeTab === 'roles' && <RolesPermissions />}
                {activeTab === 'audit' && <AuditLog />}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}